export default __webpack_public_path__ + "static/media/NR-BX471GPKA 3.b264df1e.jpg";